import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import type { KYCFlowState } from '../KYCFlowController';

interface HumanReviewScreenProps {
  state: KYCFlowState;
  // Llamado cuando el usuario confirma que leyó el resultado y cierra el widget
  onDismiss?: () => void;
}

// Pantalla de revisión humana pendiente: el score de algún documento cayó en el rango
// HUMAN_REVIEW (75–84 por defecto). El equipo de Amarello validará manualmente la sesión.
export function HumanReviewScreen({ state, onDismiss }: HumanReviewScreenProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        gap: 2,
        textAlign: 'center',
      }}
    >
      <HourglassEmptyIcon sx={{ fontSize: 72, color: 'info.main' }} />

      <Typography variant="h5" fontWeight={700}>
        Verificación en revisión
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 420 }}>
        Tu solicitud ha sido enviada para revisión por nuestro equipo de seguridad.
        Recibirás una notificación por correo electrónico en un plazo de 24 a 48 horas
        hábiles con el resultado de tu verificación.
      </Typography>

      <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 380 }}>
        No es necesario que realices ninguna acción adicional.
        Tu información ya fue recibida de forma segura.
      </Typography>

      {/* Scores acumulados durante el flujo — ayudan al usuario a entender el resultado */}
      {(state.idScore ?? state.poaScore) && (
        <Stack direction="row" spacing={1} sx={{ mt: 2 }} justifyContent="center" flexWrap="wrap">
          {state.idScore && (
            <Chip
              label={`Identificación: ${state.idScore.score}/100`}
              color="info"
              size="small"
              variant="outlined"
            />
          )}
          {state.poaScore && (
            <Chip
              label={`Comprobante: ${state.poaScore.score}/100`}
              color="info"
              size="small"
              variant="outlined"
            />
          )}
        </Stack>
      )}

      {/* El usuario debe confirmar explícitamente para cerrar el widget */}
      {onDismiss && (
        <Button
          variant="contained"
          color="info"
          onClick={onDismiss}
          sx={{ mt: 3 }}
        >
          Entendido
        </Button>
      )}
    </Box>
  );
}
